// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sBhteR9ply434VKf9Xq2{color:var(--content-primary-secondary)}.Q5nyiEsaNzcMIt8AHlrJ{background:var(--background-primary-inverted-primary);border-radius:4px;grid-template-columns:24px 1fr;align-items:center;gap:4px;height:32px;padding:4px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `sBhteR9ply434VKf9Xq2`,
	"card": `Q5nyiEsaNzcMIt8AHlrJ`
};
export default ___CSS_LOADER_EXPORT___;
